import './SearchPlaceholder.scss'

type SearchPlaceholderProps = {
  backgroundColor?: string
  placeholderText?: string
}

const SearchPlaceholder = ({
  backgroundColor = 'transparent',
  placeholderText = 'Inget resultat hittades för din sökning.',
}: SearchPlaceholderProps) => {
  return (
    <div className='search-result__placeholder' style={{ backgroundColor }}>
      {placeholderText}
    </div>
  )
}

export default SearchPlaceholder